import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { client } from './apollo/client';
import { AuthProvider } from './context/AuthContext';
import ShipList from './components/ShipList';
import ShipDetail from './components/ShipDetail';
import PassagePlanDetail from './components/PassagePlanDetail';
import ShipSearch from './components/ShipSearch';
import PassagePlanSearch from './components/PassagePlanSearch';
import Readme from './components/Readme';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import AuthCallback from './components/AuthCallback';
import UserStatus from './components/UserStatus';
import MyPage from './components/MyPage';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ApolloProvider client={client}>
        <Router>
          <div className="App">
            <header className="App-header">
              <UserStatus />
              <h1>
                <img src="/favicon.png" alt="Sail Alert" className="header-icon" />
                Sail Alert URAGA
              </h1>
              <p>浦賀水道航路船舶航行情報</p>
              <Link to="/readme" className="readme-link">注意(最初にお読み下さい)</Link>
            </header>
            <main className="App-main">
              <Routes>
                <Route path="/" element={<ShipList />} />
                <Route path="/readme" element={<Readme />} />
                <Route path="/search" element={<ShipSearch />} />
                <Route path="/passage-plan-search" element={<PassagePlanSearch />} />
                <Route path="/ship/:shipId" element={<ShipDetail />} />
                <Route path="/passage-plan/:passagePlanId" element={<PassagePlanDetail />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/mypage" element={<MyPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ApolloProvider>
    </AuthProvider>
  );
}

export default App;
